
























































































































































import CardPanel from '@/components/common/CardPanel.vue'
import {Component, Ref} from 'vue-property-decorator'
import RouterHelper from '@/mixins/RouterHelper.vue'
import SimpleUploader from "@/components/common/SimpleUploader.vue"
import { ElForm } from 'element-ui/types/form'
import { getDataContent, getExample} from '@/request/apis/common'
import { getMarkers, createTask } from '@/request/apis/CellTypeAnnotationRequest'
import SelectPanel from '@/components/common/SelectPanel.vue'
import CascaderSelect from "@/components/common/CascaderSelect.vue";

@Component({
  components: {
    CascaderSelect,
    CardPanel,
    SimpleUploader,
    SelectPanel
  }
})
export default class CellTypeAnnotationForm extends RouterHelper {
  @Ref('form') readonly submitForm!: ElForm
  @Ref('textarea') readonly textarea!: HTMLInputElement

  private markersList: any[] = []
  private clusterNameList: any[] = []
  private exampleFile: string = ''
  private loadingSelect: boolean = false
  private loadingProcessButton: boolean = false
  private type: string = 'CellTypeAnnotation'

  private form: any = {
    inputType: 'choose', // choose | file
    chooseData: '', // 选择的数据
    dataID: '', //上传的文件ID
    content: '', // 文本内容
    clusterName: '', // cluster name
    markerType: 'choose', // choose | file
    markerData: '', // 选择的参数数据
    markerID: '', // 上传的参数数据
  }

  get id () {
    return this.$route.params.id
  }

  /**
   * 级联选择器数据改变
   */
  private async handleDataChange(value: string) {
    this.form.chooseData = value
    await this.getContent()
  }

  /**
   * 根据选择数据获取marker
   */
  private async getMarker () {
    this.markersList = await getMarkers(null).start()
    this.form.markerData = this.markersList[0]
  }

  /**
   * 根据选择数据获取文本内容
   */
  private async getContent () {
    const res = await getDataContent(this.textarea, this.form.chooseData).start()
    this.form.content = res.content
    this.clusterNameList = res.cluster_name_list
    this.form.clusterName = this.clusterNameList[0]
  }

  /**
   *  获取上一步选择的数据 / 默认显示第一条数据
   */
  private async setDefaultData () {
    await this.getMarker()
    await this.getExample()
  }

  private async getExample () {
    const result = await getExample(null).start()
    this.exampleFile = result.marker_example
  }

  mounted () {
    this.setDefaultData()
  }

  /**
   * 表单提交
   */
  private submitHandler () {
    this.submitForm.validate(async (valid) => {
      if (valid) {
        this.loadingProcessButton = true
        try {
          let params: any = {
            job_id: this.id,
            cluster_label: this.form.clusterName,
          }
          if (this.form.inputType === 'file') {
            params.choose_data = this.form.dataID
          } else {
            params.choose_data = this.form.chooseData
          }
          if (this.form.markerType === 'file') {
            params.marker_id = this.form.markerID
          } else {
            params.marker = this.form.markerData
          }
          const taskDetail = await createTask(null, params).start()
          this.$emit('formSubmit', taskDetail)
        } catch (e) {
          console.warn(e)
        }
        this.loadingProcessButton = true
      } else {
        return false
      }
    })
  }

  private get rules () {
    const checkInputData = (rule: any, value: string, callback: Function) => {
      if (this.form.inputType === 'choose' && !value) {
        return callback(new Error(<string>this.$t('form.choose')))
      }
      callback()
    }
    const checkFile = (rule: any, value: string, callback: Function) => {
      if (this.form.inputType === 'file' && !this.form.dataID) {
        return callback(new Error(<string>this.$t('form.upload')))
      }
      callback()
    }
    const checkClusterName = (rule: any, value: string, callback: Function) => {
      if (!this.form.clusterName) {
        return callback(new Error(<string>this.$t('form.params.checkParams')))
      }
      callback()
    }
    const checkMarker = (rule: any, value: string, callback: Function) => {
      if (!this.form.markerData) {
        return callback(new Error(<string>this.$t('form.params.checkMarker')))
      }
      callback()
    }
    const checkMarkerFile = (rule: any, value: string, callback: Function) => {
      if (this.form.markerType === 'file' && !this.form.markerID) {
        return callback(new Error(<string>this.$t('form.upload')))
      }
      callback()
    }
    return {
      chooseData: [
        { validator: checkInputData, trigger: 'blur' }
      ],
      fileId: [
        { validator: checkFile, trigger: 'blur' }
      ],
      clusterName: [
        { validator: checkClusterName, trigger: 'blur' }
      ],
      markerData: [
        { validator: checkMarker, trigger: 'blur' }
      ],
      markerFile: [
        { validator: checkMarkerFile, trigger: 'blur' }
      ]
    }
  }
}
